import React, { useState } from 'react';
import Nav from './Nav';
import { Link } from 'gatsby';

import logo from '../assets/images/website-icon.png';

export default function SideBar({pageHeader, menuBar}) {
  const [headerOpen, toggleHeader] = useState(false);
  var menuDisplay;
  if(menuBar) {menuDisplay = <Nav onMenuToggle={() => toggleHeader(!headerOpen)} />;}
  return (
    <header id="header" className={`${pageHeader ? ' ' : 'alt'}`}>
        <Link to="/"><h1><img src={logo} alt="" /> Voodoo Shipping Company</h1></Link>
      <div className={`${headerOpen ? 'is-menu-visible' : ' '}`}>
        {menuDisplay}
      </div>
    </header>
  );
}
